import axios from '../../../../axiosRetailReleases';
import { store } from '../../../../store/store';

const currentURL = window.location.href;
const url = new URL(currentURL);
const domain = url.origin;
const POINT_EXCHANGE_LINK = '/point-exchange-policy';
const COMPANY_LINK = '/company-management';
const AGENCY_LINK = '/stores';
const PRODUCT_LINK = '/products';

const normalizeStatus = (status) => {
    if (Array.isArray(status)) {
        return status;
    }
    if (status === -1 || status === null || typeof status === 'undefined') {
        return [];
    }
    return [status];
};

const getAuthHeader = () => {
    const token = store.getState()?.auth?.detail?.token;
    return token ? { Authorization: token } : {};
};

// Chỉ lấy các công ty có status = 2 - Hoạt động
export const fetchCompanyOptions = (payload = {}) =>
    axios({
        url: '/company/get-list-company',
        method: 'POST',
        data: {
            keySearch: '',
            page: 1,
            size: 200,
            ...payload,
            link: COMPANY_LINK,
            domain,
            status: 2,
        },
        headers: getAuthHeader(),
    });

export const fetchAgencyOptions = (payload = {}) => {
    const {
        keySearch = '',
        page = 1,
        size = 200,
        companyId = [-1],
        type,
        ...rest
    } = payload;

    const requestData = {
        keySearch,
        page,
        size,
        companyId,
        ...rest,
        link: AGENCY_LINK,
        domain,
        status: normalizeStatus(2),
    };

    if (type !== undefined) {
        requestData.type = type;
    }

    return axios({
        url: '/agency/get-list-agency',
        method: 'POST',
        data: requestData,
        headers: getAuthHeader(),
    });
};

export const fetchProviderOptions = (payload = {}) => {
    const {
        keySearch = '',
        page = 1,
        size = 200,
        companyId = [-1],
        ...rest
    } = payload;

    return axios({
        url: '/agency/get-list-provider',
        method: 'POST',
        data: {
            keySearch,
            page,
            size,
            companyId,
            ...rest,
            link: '/providers',
            domain,
            status: normalizeStatus(2),
        },
        headers: getAuthHeader(),
    });
};

export const fetchPointExchangePolicies = (payload = {}) => {
    const {
        statusList,
        status,
        ...rest
    } = payload;
    
    const data = {
        page: 1,
        size: 20,
        keyword: '',
        ...rest,
        link: POINT_EXCHANGE_LINK,
        domain,
    };
    
    if (statusList !== undefined && statusList !== null) {
        data.statusList = statusList;
    } else if (status !== undefined && status !== null) {
        data.status = status;
    }
    
    return axios({
        url: '/point-exchange-policy/list',
        method: 'POST',
        data,
        headers: getAuthHeader(),
    });
};

export const fetchPointExchangePolicyDetail = (policyId) =>
    axios({
        url: `/point-exchange-policy/detail/${policyId}`,
        method: 'GET',
        params: {
            link: POINT_EXCHANGE_LINK,
            domain,
        },
        headers: getAuthHeader(),
    });

// Chỉ lấy các sản phẩm có status = 2 - Hoạt động
export const fetchProductOptions = (payload = {}) => {
    const {
        keySearch = '',
        page = 1,
        size = 100,
        type = [-1],
        isPackage = [-1],
        idCategory = [-1],
        agencyId = null,
        ...rest
    } = payload;

    return axios({
        url: '/product/list',
        method: 'POST',
        data: {
            keySearch,
            page,
            size,
            status: [2],
            type,
            isPackage,
            idCategory,
            agencyId,
            link: PRODUCT_LINK,
            domain,
            ...rest,
        },
        headers: getAuthHeader(),
    });
};

export const togglePointExchangePolicyStatus = (policyId, reason) =>
    axios({
        url: '/point-exchange-policy/toggle-status',
        method: 'POST',
        data: {
            id: policyId,
            link: POINT_EXCHANGE_LINK,
            domain,
            reason: reason || null,
        },
        headers: getAuthHeader(),
    });

export const deletePointExchangePolicy = (policyId, reason) =>
    axios({
        url: '/point-exchange-policy/delete',
        method: 'POST',
        data: {
            id: policyId,
            link: POINT_EXCHANGE_LINK,
            domain,
            reason: reason || null,
        },
        headers: getAuthHeader(),
    });

export const createPointExchangePolicy = (payload) =>
    axios({
        url: '/point-exchange-policy/create',
        method: 'POST',
        data: {
            ...payload,
            link: POINT_EXCHANGE_LINK,
            domain,
        },
        headers: getAuthHeader(),
    });

export const updatePointExchangePolicy = (payload) =>
    axios({
        url: '/point-exchange-policy/update',
        method: 'POST',
        data: {
            ...payload,
            link: POINT_EXCHANGE_LINK,
            domain,
        },
        headers: getAuthHeader(),
    });

